import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { LoginService } from 'src/app/services/Login/login.service';
import { MetadataService } from 'src/app/services/Metadata/metadata.service';
import { style } from '@angular/animations';
import { RoleService } from 'src/app/services/RoleManagement/role.service';
// import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-user-sidebar',
  templateUrl: './user-sidebar.component.html',
  styleUrls: ['./user-sidebar.component.scss']
})

export class UserSidebarComponent implements OnInit {
  loggedUserId: number = 0;
  loggedUser: any;
  protected features = { isFullScreenRequested: false, isDarkModeRequested: false };
  private documentElement: any;
  roleId: number;
  // isRefreshed = true;
  isLeftmenu: boolean = true;
  constructor(private router: Router, private loginService: LoginService, private metaService: MetadataService, @Inject(DOCUMENT) private document: any, private roleService: RoleService) {
    router.events.subscribe((event: any) => {

      if (event.constructor.name === 'NavigationEnd') {

        this.hideLeftSideMenu(event.url)
      }
      // this.isRefreshed = false;
    });

    this.roleService.userDetail$.subscribe(detail => {
      const {userId, roleId} = detail
      this.loggedUserId = userId
      this.roleId= roleId
    })

  }
  hideLeftSideMenu(pathName: string) {
    let right_side_block = document.getElementById('right_side_block');

    if (pathName === "/contact" || pathName === "/contact/AddContact") {
      this.isLeftmenu = true;
      right_side_block.style.width = "100%";
    } else if (pathName === "/search") {
      this.isLeftmenu = true;
      right_side_block.style.width = "83%";
    } else {
      this.isLeftmenu = true;
      right_side_block.style.width = "83%";
    }
  }

  ngOnInit() {

    // if (this.isRefreshed) {
    //   //will call only when page reload happens
    //   console.log("pathanme----", window.location.pathname)
    //   let pathName = window.location.pathname;
    //   this.hideLeftSideMenu(pathName)

    // }



    // update document element to a variable
    this.documentElement = document.documentElement;

    if (!(this.loggedUserId > 0)) {
    }
    else {
      this.metaService.GetAllRoles().subscribe((rolesRes: any) => {
        var roles = rolesRes;
        this.loginService.GetUserById(this.loggedUserId).subscribe((userRes: any) => {
          this.loggedUser = userRes;
          this.loggedUser.role = roles.filter((x: any) => x.id == userRes.roleId)?.[0]?.name;
        })
      })
    }

    // Retrieve the stored state from local storage
    const storedIsLeftmenu = localStorage.getItem('isLeftmenu');
    if (storedIsLeftmenu !== null) {
      this.isLeftmenu = storedIsLeftmenu === 'true';
    }

  }

  openFullscreen() {
    this.features.isFullScreenRequested = true;
    if (this.documentElement.requestFullscreen) {
      this.documentElement.requestFullscreen();
    } else if (this.documentElement.mozRequestFullScreen) {
      /* Firefox */
      this.documentElement.mozRequestFullScreen();
    } else if (this.documentElement.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.documentElement.webkitRequestFullscreen();
    } else if (this.documentElement.msRequestFullscreen) {
      /* IE/Edge */
      this.documentElement.msRequestFullscreen();
    }
  }
  /* Close fullscreen */
  closeFullscreen() {
    this.features.isFullScreenRequested = false;
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }



  GotoMydashboard() { this.router.navigate(['/dashboard']) }
  GotomySystemAdmins() { this.router.navigate(['/admins']) }
  GotoCompanyOffices() { this.router.navigate(['/company-offices']) }
  GotoBroker() { this.router.navigate(['/broker']) }
  GotoOfficeManager() { this.router.navigate(['/office-manager']) }
  GotoAgent() { this.router.navigate(['/agent']) }
  // LogoutUser(){this.router.navigate(['/login'])}
  GotoContacts() { this.router.navigate(['/contact']) }

  LogoutUser() {
    localStorage.removeItem("LoggedUserToken");
    this.roleService.resetDetails()
    this.router.navigate(['login']);
    location.reload();
  }

  Userprofile() {
    this.router.navigate(['/profile'])
  }
}
